<template>
	<div :class="['logo', getMenuState && getMobile ? 'logo--disable' : '', getRouteLeave ? 'logo--leave' : '']">
		<router-link to="/">
			<h1>LÉO ARNAUD</h1>
		</router-link>
	</div>
</template>

<script>
	export default {
		name: 'logo',
		computed: {
			getMobile () {
				return this.$store.getters.getMobile
			},
			getMenuState () {
				return this.$store.getters.getMenuState
			},
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			}
		}
	}
</script>

<style lang="scss">
	.logo {
		transition: all .6s cubic-bezier(0.215, 0.61, 0.355, 1);

		a {
			letter-spacing: 0.01em;
			transition: all .6s cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		
		&--disable {
			opacity: 0;
		}

		&--leave {
			transform: translateY(-20px);
			opacity: 0;
		}

		h1 {
			margin: 0 30px 0 0;
			font-weight: 100;
			text-transform: uppercase;
			@include fontSize(25);

			@include mobile {
				@include fontSize(20);
			}
		}

		&:hover {
			opacity: .5;
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/common/header/Logo.vue?754a1e52